import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteResellerOrdersNotesForAdmin } from "./deleteResellerOrdersNotesForAdmin.request";

const useDeleteResellerOrdersNotesForAdmin = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchOrdersListAndDetails = useRefetchQuery(["order"]);

  return useMutation({
    mutationFn: requestDeleteResellerOrdersNotesForAdmin,
    ...options,
    onSuccess: (...args) => {
      refetchOrdersListAndDetails();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteResellerOrdersNotesForAdmin;
